import React from "react"
import clsx from 'clsx'
import I18n from "i18n-js"
import DateHelper from '../../DateHelper/DateHelper';
import { parseISO, format } from 'date-fns';
import AddButton from '../../AddButton/AddButton';
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";

export default class MessageLogConversation extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      message: '',
      messages: this.props.messages,
      loading: false,
      reply: {},
    }
    this.onChange = this.onChange.bind(this)
    this.renderMessages = this.renderMessages.bind(this)
    this.resolveMessages = this.resolveMessages.bind(this)
    this.addReply = this.addReply.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
  }


  render() {
    var tabClasses = clsx({
      'active': this.props.message_active_tab == 'conversation',
      'tab-pane': true
    });
    
    return (
      <div className={tabClasses} id="conversation">
        <div className='panel panel-default'>
          <div className='panel-heading'>
            <h3 className="panel-title pull-left d-flex">{this.props.messages_formatted_phone} {!this.props.opted_in ? <span className="ss-alert d-flex align-items-center ml-1" title={I18n.t('phone_number_is_not_opted_in')}></span> : null}</h3>
          </div>
          <div className="panel-body container">
            <div className="row">
              <div className="col-md-12">
                <div className="message-container">
                  {this.renderMessages()}
                  {this.renderForm(this.props.messages_phone)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  renderMessages() {
    var messages = this.state.messages.map((message, idx) => {
      return (
        <div key={idx} className={`message mb-2${message.message_type == "outgoing" ? " outgoing" : ""}`}>
          <div className={message.message_type == 'outgoing' ? 'float-right' : 'float-left'} style={{display: 'flex', flexDirection:'column'}}>
            {message.images ? 
              <div className="content-container">
                <div className={`content-image ${message.message_type == 'outgoing' ? 'float-right' : 'float-left'}`}>
                  {message.images.map((image, idx) => {
                    return <img key={idx} src={image}/>
                  })}
                </div>
              </div>
              :
              null
            }
            <div className="content-container">
              <div className="content">
                {message.body}
              </div>
              <div className="date">
                {format(DateHelper.hotelAdjustDate(parseISO(message.sent_at)), DateHelper.rubyToDateFNS(this.props.date_format) + ' ' + DateHelper.rubyToDateFNS(this.props.time_format))}
                {message.status == "resolved" ? <span className="ss-check status"></span> : ""}
                {message.status == "failed" ? <span className="ss-alert status" title={`${message.status}: ${message.error}`}></span> : ""}
              </div>           
            </div>
          </div>
        </div>
      )
    })
    return (
      <div className="messages">
      {messages}
      </div>
    )
  }

  renderForm(messages_phone) {
    return(
      <div className="btn-group reply-box col-md-12">
          <input type="text" className="form-control" value={this.state.message} onChange={this.onChange} readOnly={this.props.read_only}/>
          <button onClick={this.resolveMessages} disabled={this.props.read_only} className="btn btn-secondary resolve-btn">{I18n.t("resolve")}</button>
          <AddButton model="Reply" text={I18n.t('preset')} disabled={this.props.read_only} buttonClasses="btn btn-secondary addReply" new_button={false} onAdd={this.addReply} data={this.props.replies} reply={true}/>
          <button onClick={(e) => this.sendMessage(e, messages_phone)} disabled={this.props.read_only} className="btn btn-secondary">{I18n.t("send")}</button>
      </div>
    )
  }

  resolveMessages() {
    var self = this
    
    self.setState({ loading: true })
    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: `/admin/messages_resolve/${self.state.messages.map(m => m.id).join(',')}`,
      }).done(function (data) {
        self.setState({ messages: data.messages, loading: false })
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('messages_resolved_successfully'));
        }
        parent.window.refreshUnresolvedMessageIcon();
      })
    }, 1000)
  }

  addReply(reply) {
    var self = this
    
    self.setState({ message: reply.body})
  }

  sendMessage(e, messages_phone) {
    var self = this
    self.setState({ loading: true })
    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: self.props.send_messages_path,
        data: {
          message: self.state.message,
          messages_phone: messages_phone,
        },
      }).done(function (data) {
        self.setState({ messages: data.messages, message: '', loading: false })
        
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('message_sent_successfully'));
        }
        parent.window.refreshUnresolvedMessageIcon();
        e.target.blur()
      })
    }, 1000)
  }

  onChange(e) {
    this.setState({
      message: e.target.value
    })
  }
}